import { render, staticRenderFns } from "./add-operational-projects.vue?vue&type=template&id=3765b81f&scoped=true&"
import script from "./add-operational-projects.vue?vue&type=script&lang=js&"
export * from "./add-operational-projects.vue?vue&type=script&lang=js&"
import style0 from "./add-operational-projects.vue?vue&type=style&index=0&id=3765b81f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3765b81f",
  null
  
)

export default component.exports